<template>
  <div>
    <!--begin: Head -->
    <div
      class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
      id="dropUser-bg"
    >
      <div class="kt-user-card__avatar">
        <img class="" alt="Pic" :src="displayProfilePicture" />
      </div>
      <div class="kt-user-card__name" @click="onClickButton()">
        {{ currentProfile.name }}
      </div>
    </div>
    <!--end: Head -->

    <!--begin: Navigation -->
    <div class="kt-notification">
      <a
        href="javascript:void(0)"
        @click="redirect('/central/profile')"
        class="kt-notification__item"
      >
        <div class="kt-notification__item-icon">
          <i class="fal fa-id-badge kt-font-dark"></i>
        </div>
        <div class="kt-notification__item-details">
          <div class="kt-notification__item-title kt-font-bold">My Profile</div>
          <div class="kt-notification__item-time">
            Account settings and more
          </div>
        </div>
      </a>
      <router-link
        style="display: none"
        v-if="isAllowedToAccessCompanySettings"
        to="/company-settings"
        class="kt-notification__item"
      >
        <div class="kt-notification__item-icon">
          <i class="fal fa-id-badge kt-font-dark"></i>
        </div>
        <div class="kt-notification__item-details">
          <div class="kt-notification__item-title kt-font-bold">
            Company Settings
          </div>
          <div class="kt-notification__item-time">
            Company settings and more
          </div>
        </div>
      </router-link>
      <a href="javascript:void(0)" @click="showInviteLink()">
        <div class="kt-notification__item">
          <div class="kt-notification__item-icon">
            <i class="fa fa-link kt-font-dark"></i>
          </div>
          <div class="kt-notification__item-details">
            <div class="kt-notification__item-title kt-font-bold">
              Invitation Link
            </div>
            <div class="kt-notification__item-time">
              Invite your colleague to sign up
            </div>
          </div>
        </div>
      </a>
      <div class="kt-notification__custom kt-space-between">
        <a
          href="#"
          class="btn btn-label btn-label-dark btn-sm btn-bold"
          @click="logout"
        >
          Sign Out
        </a>
      </div>
    </div>
    <!--end: Navigation -->
    <invite-link-dialog v-model="showInviteLinkDialog" />
  </div>
</template>
<script>
import { some as _some } from 'lodash-es';
import InviteLinkDialog from './InviteLinkDialog.vue';

export default {
  name: 'DropUser',
  components: {
    InviteLinkDialog,
  },
  data() {
    return {
      showInviteLinkDialog: false,
    };
  },
  computed: {
    displayProfilePicture() {
      return this.currentProfile.profilePicture
        ? `https://webinarinc-v2-development.s3-us-west-2.amazonaws.com/users/${this.currentProfile.id}/${this.currentProfile.profilePicture}`
        : 'https://webinarinc-v2-development.s3-us-west-2.amazonaws.com/default/default_profile_picture.jpg';
    },
    currentProfile() {
      return this.$store.state.profile.value;
    },
    isAllowedToAccessCompanySettings() {
      const { roles } = this.$auth.user();

      return (
        _some(roles, { name: 'super-administrator' }) ||
        _some(roles, { name: 'account-manager' }) ||
        _some(roles, { name: 'specific-dealer-manager' })
      );
    },
  },
  methods: {
    logout() {
      this.$http.get('okta/logout').then(({ data }) => {
        this.$auth.logout();
        localStorage.removeItem('nextUrl');
        window.location.href = data;
      });
    },
    showInviteLink() {
      this.showInviteLinkDialog = true;
    },
    redirect(url) {
      window.open(url, '_blank');
    },
  },
};
</script>
<style lang="stylus">
#dropUser-bg
  background-image url('../../../../assets/images/user-bg.jpg')
</style>
